import script from "./reset-password.vue?vue&type=script&setup=true&lang=js"
export * from "./reset-password.vue?vue&type=script&setup=true&lang=js"

import "./reset-password.vue?vue&type=style&index=0&id=7569b020&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7569b020"]])

export default __exports__